import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em"
  }, props), React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9
  }), React.createElement("g", {
    fill: "#fff"
  }, React.createElement("circle", {
    cx: 9.001,
    cy: 5,
    r: 1.25
  }), React.createElement("path", {
    d: "M8.1 8.25h1.8v6H8.1z"
  })));
};

export default SvgComponent;